'use client';

import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import breakpoints from '@/lib/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';

import { ArticleObject } from '@/models/Articles';

import FeaturedArticles from './articles/FeaturedArticles';
import SimpleArticle from './articles/SimpleArticle';

export default function ArticlesList(props: ArticleObject) {
  const { title, slug, featuredImage, ...rest } = props;
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints.md})`);
  const [desktop, setDesktop]: [
    boolean | undefined,
    Dispatch<SetStateAction<boolean | undefined>>,
  ] = useState();

  useEffect(() => {
    setDesktop(isDesktop);
  }, [isDesktop]);

  return desktop ? (
    <FeaturedArticles
      className='md:h-[400px]'
      title={title || ''}
      titleSpan='1'
      titleSize='medium'
      slug={slug}
      featuredImage={featuredImage}
      {...rest}
    />
  ) : (
    <SimpleArticle
      title={title}
      featuredImage={featuredImage}
      slug={slug}
      {...rest}
    />
  );
}
